import { Component, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";

@Component({})
export default class FormAuthorization extends Vue {
  validateUserEdit(authorId) {
    let validate = false;

    if (typeof authorId == "string" || typeof authorId == "number") {
      validate = authorId == userModule.user.id;
      console.log("type nurmanulan", validate);
    }

    if (authorId instanceof Array) {
      validate = authorId.includes(userModule.user.id);
      console.log("type nurmanulan", validate);
    }

    if (!validate) {
      alert("Tidak bisa mengubah catatan yang dibuat atas nama pengguna lain!");
      return false;
    }

    return true;
  }
}
